import { lazy } from 'react';

const TimeSheetAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/timesheet',
      component: lazy(() => import('./NewTimeSheets/TimesheetApp')),
    },
    
  ],
};

export default TimeSheetAppConfig;
